import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import { AuthProvider } from "./shared/Contexts/Auth/AuthProvider";
import { NotificationsProvider } from "./shared/Contexts/Notifications/NotificationsProvider";
import { LoaderProvider } from "./shared/Contexts/Loader/LoaderProvider";

function App() {
  return (
    <BrowserRouter>
      <LoaderProvider>
        <AuthProvider>
          <NotificationsProvider>
            <AppRoutes />
          </NotificationsProvider>
        </AuthProvider>
      </LoaderProvider>
    </BrowserRouter>
  );
}

export default App;
